export default "__VITE_ASSET__51cc9cb2__"